import styled, { css } from 'styled-components';
import { redColor, greenColor, lightGrey3Color } from 'js/config/style';

const statusStyle = {
  successful: css`
    font-weight: 500;
    color: ${greenColor};
  `,
  failed: css`
    font-weight: 500;
    color: ${redColor};
  `,
  void: css`
    font-weight: 500;
    color: ${lightGrey3Color};
  `,
};

export default styled.div`
  grid-area: result;
  align-self: center;
  ${({ status }) => statusStyle[status]};
`;
